export const formatPhoneNumber = (phoneNumber: string | undefined) => {
    if (!phoneNumber) return;
    const partOne = phoneNumber.slice(0, 4);
    const partTwo = phoneNumber.slice(4, 8);
    const partThree = phoneNumber.slice(8);
    return `${partOne} ${partTwo} ${partThree}`;
};
